<template>
  <div>
    <b-modal
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title mr-2">{{ Number(data.month.split('-')[0]) - 1911 }}-{{ data.month.split('-')[1] }}身故理賠的會員</h5>

        <convert-excel
          class="btn btn-success btn-sm"
          :data="excel_json.data"
          :fields="excel_json.fields"
          :worksheet="excel_json.worksheet"
          :name="excel_json.name"
          :type="excel_json.type"
        >
          下載
        </convert-excel>

        <button type="button" aria-label="Close" class="close" @click="close()">×</button>
      </template>

      <div class="container-fluid overflow-auto">
        <div class="search-block">
          <date-picker
            v-model="search.pay_at_S"
            :position="'left'"
            placeholder="發放日期開始"
          ></date-picker>

          <date-picker
            v-model="search.pay_at_E"
            :position="'left'"
            placeholder="發放日期結束"
          ></date-picker>

          <b-button variant="success" @click="getMember(1)">搜尋</b-button>
        </div>

        <tables-page
          :tableData="table_data"
          :tableFields="table_fields"
          v-on:result="getMember"
        >
          <template #cell(join_date)="row">
            {{ convertRocDate(row.item.join_date, false) }}
          </template>

          <template #cell(dead_at)="row">
            {{ convertRocDate(row.item.dead_at, false) }}
          </template>

          <template #cell(accept_at)="row">
            {{ convertRocDate(row.item.accept_at, false) }}
          </template>

          <template #cell(seniority)="row">
            <template v-if="row.item.seniority_day >= 30">{{ row.item.seniority_month }}個月</template>

            <template v-else>{{ row.item.seniority_day }}天</template>
          </template>
        </tables-page>
      </div>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import ConvertExcel from "@/components/common/ConvertExcel";
import contractApi from "@/models/API/contractApi";
import { convertRocDate, convertDateFormat, getFirstAndLastDayOfMonth } from "@/models/HELPERS/common.js";
import datePicker from '@/components/common/DatePicker';

export default {
  name: 'MonthlyDeceasedClaimsContractModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {
    TablesPage,
    ConvertExcel,
    datePicker
  },
  data () {
    return {
      status: {
        isLoading: false
      },
      search: {
        pay_at_S: '',
        pay_at_E: ''
      },
      table_fields: [
        {
          key: "no",
          label: "No"
        },
        {
          key: "sales_number",
          label: "業務編號",
          sortable: true
        },
        {
          key: "sales_name",
          label: "業務姓名",
          sortable: true
        },
        {
          key: "number",
          label: "契約編號",
          sortable: true
        },
        {
          key: "join_date",
          label: "入會日期",
          sortable: true
        },
        {
          key: "dead_at",
          label: "身故日期",
          sortable: true
        },
        {
          key: "accept_at",
          label: "受理日期",
          sortable: true
        },
        {
          key: "member_ID_number",
          label: "互助人身分證",
          sortable: true
        },
        {
          key: "member_name",
          label: "互助人",
          sortable: true
        },
        {
          key: "pay_name",
          label: "要助人",
          sortable: true
        },
        {
          key: "seniority",
          label: "年資"
        },
        {
          key: "servicer",
          label: "愛心天使站服務人"
        }
      ],
      table_data: [],
      page: {},
      table_sort: {
        sortBy: '',
        sort: ''
      },
      excel_json: {
        fields: {},
        data: [],
        worksheet: 'My Worksheet',
        name: '每組每月慰問金統計.csv',
        type: 'csv'
      }
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.resetFields();

          this.getMember();
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.page = Object.assign({}, this.contractApi.page);
    },
    convertRocDate,
    // 查詢契約
    getMember(pageIndex = null, sortBy = '', sort = '') {
      this.status.isLoading = true;

      if (sortBy) this.table_sort.sortBy = sortBy;
      if (sort) this.table_sort.sort = sort;

      const params = {
        ...this.search,
        'sortBy': this.table_sort.sortBy,
        'sort': this.table_sort.sort,
      };

      this.contractApi.getMember((response) => {
        const res = response.data;

        this.table_data = res.data.map((item, index) => {
          return {
            ...item,
            no: index + 1
          }
        });

        this.initCsvData();

        this.status.isLoading = false;
      }, params, false)
    },
    // 重置欄位
    resetFields() {
      this.search = {
        pay_at_S: getFirstAndLastDayOfMonth(`${this.data.month}-01`).first_day,
        pay_at_E: getFirstAndLastDayOfMonth(`${this.data.month}-01`).last_day
      }
    },
    // 初始化csv資料
    initCsvData() {
      let fields = {}, data = [];

      this.table_fields.forEach(fields_item => {
        fields = {
          ...fields,
          [fields_item.label]: fields_item.key
        }
      })

      this.table_data.forEach(data_item => {
        let temp_data = {};

        this.table_fields.forEach(fields_item => {
          if (fields_item.key === 'join_date' || fields_item.key === 'dead_at' || fields_item.key === 'accept_at') {
            temp_data = {
              ...temp_data,
              [fields_item.key]: data_item[fields_item.key] ? convertDateFormat(data_item[fields_item.key], false) : ''
            }
          } else if (fields_item.key === 'seniority') {
            const show_month = data_item.seniority_day >= 30;

            temp_data = {
              ...temp_data,
              [fields_item.key]: show_month ? `${data_item.seniority_month}個月` : `${data_item.seniority_day}天`
            }
          } else {
            temp_data = {
            ...temp_data,
              [fields_item.key]: data_item[fields_item.key] !== null ? data_item[fields_item.key] : ''
            }
          }
        })

        data.push(temp_data)
      })

      this.excel_json.fields = fields;
      this.excel_json.data = data;
    },
  }
}
</script>

<style lang="scss" scoped>
.search-block {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-block: 20px;
}

@media screen and (max-width: 900px) {
  .search-block {
    .date-picker-control {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/MonthlyDeceasedClaimsContractModal.vue